import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { ProductService } from '@app/api/product.service';
import { UtilService } from '@app/services/util.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-cart-suggestions',
  templateUrl: './cart-suggestions.component.html',
  styleUrls: ['./cart-suggestions.component.scss'],
})
export class CartSuggestionsComponent implements OnInit, OnChanges {
  @Input() keyword: string = '';
  @Input() cartProducts: any[] = [];

  // static: false vì element này nằm trong *ngIf
  @ViewChild('widgetsContent', { read: ElementRef, static: false })
  public widgetsContent: ElementRef<any>;

  suggestedProducts: any[] = [];
  host = environment.backendhost;
  loading = false;
  pageSize: number = 10;
  pageIndex: number = 1;

  constructor(
    private productService: ProductService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    // Theo dõi cả keyword và cartProducts thay đổi
    if (changes.keyword || changes.cartProducts) {
      // Chỉ gọi khi có keyword thực sự
      if (this.keyword && this.keyword.trim() !== '') {
        console.log('CartSuggestion: Detect changes -> Calling API with:', this.keyword);
        this.getSuggestions(this.keyword);
      }
    }
  }

  getSuggestions(keyword: string) {
    // Chỉ hiện loading nếu chưa có sản phẩm nào
    if (this.suggestedProducts.length === 0) {
      this.loading = true;
      this.cdr.detectChanges();
    }

    this.productService
      .apiProductsSearchsGet(
        keyword,
        'is_hidden==false',
        '',
        this.pageIndex,
        this.pageSize,
        null,
        null,
        null,
        null,
        null
      )
      .subscribe(
        (res: any) => {
          let primaryList = [];

          if (res && res.success && res.data && Array.isArray(res.data.collection)) {
            // Lọc sản phẩm trùng với giỏ hàng
            primaryList = this.filterOutCartItems(res.data.collection);
          }

          console.log('CartSuggestion: Found items via keyword:', primaryList.length);

          // LOGIC: Nếu ít kết quả (< 6) VÀ giỏ hàng có đồ -> Tìm thêm theo Category
          if (primaryList.length < 6 && this.cartProducts && this.cartProducts.length > 0) {
            this.suggestedProducts = primaryList; // Hiển thị tạm

            // Lấy an toàn Category ID
            const refProduct = this.cartProducts[0];
            const categoryId = this.getSafeCategoryId(refProduct);

            if (categoryId) {
              console.log(
                'CartSuggestion: Too few items, fetching more from Category:',
                categoryId
              );
              this.fillMoreProducts(categoryId, primaryList);
            } else {
              this.finalizeLoading();
            }
          } else {
            // Đủ số lượng hoặc không có category để gợi ý -> Hiển thị luôn
            this.suggestedProducts = primaryList;
            this.finalizeLoading();
          }
        },
        (err) => {
          console.error('CartSuggestion Error:', err);
          this.finalizeLoading();
        }
      );
  }

  fillMoreProducts(categoryId: string, existingItems: any[]) {
    this.productService
      .apiProductsSearchsGet(
        '', // Không cần keyword
        'is_hidden==false',
        '',
        1,
        10,
        null,
        categoryId, // Tìm theo Category
        null,
        null,
        null
      )
      .subscribe(
        (res: any) => {
          if (res && res.success && res.data && Array.isArray(res.data.collection)) {
            let moreItems = this.filterOutCartItems(res.data.collection);

            // Lọc trùng với danh sách đã tìm được ở bước 1
            moreItems = moreItems.filter(
              (newItem) => !existingItems.some((exItem) => exItem.id === newItem.id)
            );

            // Gộp danh sách
            this.suggestedProducts = [...existingItems, ...moreItems];
          }
          this.finalizeLoading();
        },
        (err) => {
          console.error(err);
          this.finalizeLoading();
        }
      );
  }

  // Hàm lấy Category ID an toàn (tránh lỗi undefined)
  getSafeCategoryId(item: any): string | null {
    if (!item) return null;
    if (item.product_category_id) return item.product_category_id;
    if (item.extend_product && item.extend_product.product_category_id) {
      return item.extend_product.product_category_id;
    }
    return null;
  }

  filterOutCartItems(list: any[]): any[] {
    if (!this.cartProducts || this.cartProducts.length === 0) return list;
    return list.filter((item) => {
      // product_id là ID trong giỏ hàng, id là ID của sản phẩm tìm kiếm
      const isInCart = this.cartProducts.some((cartItem) => cartItem.product_id === item.id);
      return !isInCart;
    });
  }

  finalizeLoading() {
    this.loading = false;
    // Bắt buộc gọi detectChanges để cập nhật UI ngay lập tức
    this.cdr.detectChanges();
  }

  // --- Scroll Logic ---
  public scrollRight(): void {
    if (this.widgetsContent && this.widgetsContent.nativeElement) {
      this.widgetsContent.nativeElement.scrollTo({
        left: this.widgetsContent.nativeElement.scrollLeft + 300,
        behavior: 'smooth',
      });
    }
  }

  public scrollLeft(): void {
    if (this.widgetsContent && this.widgetsContent.nativeElement) {
      this.widgetsContent.nativeElement.scrollTo({
        left: this.widgetsContent.nativeElement.scrollLeft - 300,
        behavior: 'smooth',
      });
    }
  }

  goToProductDetail(product: any) {
    if (!product.id || !product.name) return;
    const slug = UtilService.slugify(product.name);
    this.router.navigate([`/product/${product.id}/${slug}/details`]);
  }
}
